import React from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { CardActions } from '@mui/material';
import Button from '../UI/Button';
import { dateTimeFormat } from '../../util/DateUtil';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '80%',
    },
    title: {
        fontSize: 25,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function VotacaoUsuarioProfile({ votacaoUsuario, handleTrocaVotacaoUsuario }) {
    const classes = useStyles();

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <Grid container justifyContent='space-between' spacing={3}>
                    <Grid
                        justifyContent='center'
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Título
                        </Typography>
                        <Typography variant="body1" component="h2">
                            {votacaoUsuario?.votacao.titulo ? votacaoUsuario?.votacao.titulo : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        justifyContent='center'
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Descrição
                        </Typography>
                        <Typography variant="body1" component="h2">
                            {votacaoUsuario?.votacao.descricao ? votacaoUsuario?.votacao.descricao : ''}
                        </Typography>
                    </Grid>
                    <Grid
                        justifyContent='center'
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Quant. Máx. Seleção
                        </Typography>
                        <Typography variant="body1" component="h2">
                            {votacaoUsuario?.votacao.quantUsuarioOpcao ? votacaoUsuario?.votacao.quantUsuarioOpcao : ''}
                        </Typography>
                    </Grid>
                    {votacaoUsuario.votacao.visulizarResultadoAPartirDe &&
                        <Grid
                            justifyContent='center'
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 4
                            }}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Data Visualizar Resultados
                            </Typography>
                            <Typography variant="body1" component="h2">
                                {votacaoUsuario?.votacao.dataHoraVisualizarResultadoAPartirDe ? dateTimeFormat(votacaoUsuario?.votacao.dataHoraVisualizarResultadoAPartirDe) : ''}
                            </Typography>
                        </Grid>
                    }
                    <Grid size={12}>
                        <CardActions>
                            <Button
                                onClick={handleTrocaVotacaoUsuario}
                                size="small"
                                color="secondary"
                                variant="contained"
                            >Trocar Votação</Button>
                        </CardActions>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    );
}